import { ownerColor } from "@/lib/palette";

/**
 * Reusable user avatar: shows the uploaded photo when available,
 * otherwise a colored circle with the person's initial.
 */
export default function Avatar({ user, size = 20, className = "", title }) {
  const px = typeof size === "number" ? size : 20;
  const name = user?.name || "?";
  const initial = name.slice(0, 1).toUpperCase();
  const col = ownerColor(user?.id);
  const baseStyle = { width: px, height: px };
  const label = title ?? name;

  if (user?.avatar) {
    return (
      <img
        src={user.avatar}
        alt={name}
        title={label}
        style={baseStyle}
        draggable={false}
        className={`rounded-full object-cover shrink-0 ${className}`}
      />
    );
  }
  return (
    <div
      title={label}
      style={{
        ...baseStyle,
        backgroundColor: col.primary,
        color: col.text,
        fontSize: Math.max(9, Math.round(px * 0.42)),
      }}
      className={`rounded-full grid place-items-center font-bold shrink-0 ${className}`}
    >
      {initial}
    </div>
  );
}
